export default __webpack_public_path__ + "static/media/Rectangle 51.513397a6.png";